/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CancelRequestBuilderRequestsMetadata, type CancelRequestBuilder } from './cancel/index.js';
// @ts-ignore
import { RetryRequestBuilderRequestsMetadata, type RetryRequestBuilder } from './retry/index.js';
// @ts-ignore
import { StatusRequestBuilderRequestsMetadata, type StatusRequestBuilder } from './status/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /jobs/{id}
 */
export interface JobsItemRequestBuilder extends BaseRequestBuilder<JobsItemRequestBuilder> {
    /**
     * The cancel property
     */
    get cancel(): CancelRequestBuilder;
    /**
     * The retry property
     */
    get retry(): RetryRequestBuilder;
    /**
     * The status property
     */
    get status(): StatusRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const JobsItemRequestBuilderUriTemplate = "{+baseurl}/jobs/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const JobsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof JobsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    cancel: {
        requestsMetadata: CancelRequestBuilderRequestsMetadata,
    },
    retry: {
        requestsMetadata: RetryRequestBuilderRequestsMetadata,
    },
    status: {
        requestsMetadata: StatusRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
